import React, { useEffect, useState } from 'react';
import api from '../../api/config';
import { useNavigate } from 'react-router-dom';

const YurtIlanlar = () => {
    const [yurtPersonelIlanlar, setYurtPersonelIlanlar] = useState([]);
    const [yurtYoneticiIlanlar, setYurtYoneticiIlanlar] = useState([]);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const fetchIlanlar = async () => {
        try {
            const [personel, yonetici] = await Promise.all([
                api.get('/api/yurt-personel-ilanlar'),
                api.get('/api/yurt-yonetici-ilanlar')
            ]);
            setYurtPersonelIlanlar(personel.data);
            setYurtYoneticiIlanlar(yonetici.data);
        } catch (err) {
            console.error('Yurt ilanları alınırken hata:', err);
            setError('Yurt ilanları alınırken bir hata oluştu.');
        }
    };

    useEffect(() => { fetchIlanlar(); }, []);

    const renderIlan = (ilan, tip) => (
        <li key={ilan.id}>
            <h3>{ilan.ilan_basligi} - {ilan.firma_adi}</h3>
            <p>İş Tipi: {ilan.is_tipi}</p>
            <p>Şehir: {ilan.sehir}</p>
            <p>Detaylar: {ilan.detaylar}</p>
            <p>Maaş: {ilan.maas}</p>
            <p>İlan Tarihi: {ilan.ilan_tarihi}</p>
            <button onClick={() => navigate(`/yurt-${tip}-ilanlar/${ilan.id}`)}>Başvur</button>
        </li>
    );

    return (
        <div>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <h1>Yurt Yönetici İlanları</h1>
            <ul>{yurtYoneticiIlanlar.map(ilan => renderIlan(ilan, 'yonetici'))}</ul>
            <h1>Yurt Personel İlanları</h1>
            <ul>{yurtPersonelIlanlar.map(ilan => renderIlan(ilan, 'personel'))}</ul>
        </div>
    );
};

export default YurtIlanlar;